import classNames from 'clsx';
import React from 'react';
import type { TableInstance } from 'react-table';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import { useIsMobileDevice } from '@swf/poker';

import styles from '../Members.scss';
import useActionButtons from '../hooks/useActionButtons';

import { TXTCLI_Unblock } from './ActionButtons.messages.json';

const ActionButtons: React.FC<{ tableInstance: TableInstance<object> }> = ({ tableInstance }) => {
  const { disabled, handleClick } = useActionButtons({
    tableInstance,
    callbackStatuses: ['HG_MEMBERSHIP_STATUS_BLOCKED', 'HG_MEMBERSHIP_STATUS_BANNED']
  });

  const isMobileDevice = useIsMobileDevice();

  return (
    <div
      className={classNames({
        [styles.actionButtons]: !isMobileDevice,
        [styles.mobileButtons]: isMobileDevice,
        [styles.hidden]: disabled
      })}
    >
      <StarsButton
        className={styles.tertiaryButton}
        disabled={disabled}
        data-action="HG_UNBLOCK_PLAYER"
        variant="tertiary"
        size={isMobileDevice ? undefined : 'small'}
        translation={TXTCLI_Unblock}
        onClick={handleClick}
      />
    </div>
  );
};

export default ActionButtons;
